module.exports = __webpack_public_path__ + "static/media/product-default.da20127f.png";